import styled from 'styled-components'

export const ListCellContainer = styled.ul`
  font-size: small;
  font-weight: normal;
  align-items: flex-start;
  padding: 0 0 0 1.6em;
  margin: 0;
`

export const ListCellItem = styled.li`
  margin: 0px 6px 0px 0px;
`
